import { getPaymentTitle } from './getPaymentTitle';

export const getFields = (selectedRefund) => {
    return [
        {
            label: 'Name:',
            value: `${selectedRefund?.consultant?.name} ${selectedRefund?.consultant?.surname}`,
        },
        {
            label: 'Amount:',
            value: selectedRefund?.amount,
        },
        {
            label: 'Bank account number:',
            value: selectedRefund?.consultant?.bank_account_number,
        },
        {
            label: 'Title:',
            value: getPaymentTitle(selectedRefund?.reason),
        },
    ];
};